
import { Vue, Component, Prop } from "vue-property-decorator";


@Component({

})
export default class AlertModel extends Vue {
  @Prop({type: String, default: "#010A11"}) stroke: string

}
